import styled from 'styled-components'

const MAX_DIGIT_WIDTH_PX = 10
const MIN_DIGITS = 2
// The field keeps its own width so the control does not stretch as digits are
// typed; past this many the value scrolls inside the field instead.
const MAX_DIGITS = 5

interface IQuantityValueInputStyledProps {
  numDigits: number
}

const toFieldWidth = (numDigits: number): number =>
  Math.min(Math.max(numDigits, MIN_DIGITS), MAX_DIGITS) * MAX_DIGIT_WIDTH_PX

/**
 * The doubled class outweighs the legacy form styling in
 * `emma-ui/src/styles/forms/forms.scss`, which reaches every `input[type=text]`
 * in the app with a height, a 1em padding and a border. A single generated
 * class loses to that selector, and the padding alone leaves this field no
 * room to draw its digits.
 */
export const QuantityValueInputStyled = styled.input<IQuantityValueInputStyledProps>`
  && {
    flex: 1 1 auto;
    width: ${({ theme, numDigits }) =>
      theme.typography.pxToRem(toFieldWidth(numDigits))};
    min-width: ${({ theme, numDigits }) =>
      theme.typography.pxToRem(toFieldWidth(numDigits))};
    height: auto;

    padding: 0;
    border: none;
    border-radius: 0;
    background-color: transparent;

    color: ${({ theme }) => theme.colors.text.primary};
    font-family: inherit;
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    line-height: normal;
    text-align: center;

    &:focus {
      outline: none;
    }

    /* The quantity stays readable while the control is disabled, the way the
     * read-only display renders it. A disabled input greys its own text in
     * WebKit, so the fill colour is pinned alongside the colour. */
    &:disabled {
      color: ${({ theme }) => theme.colors.text.primary};
      -webkit-text-fill-color: ${({ theme }) => theme.colors.text.primary};
      background-color: transparent;
      opacity: 1;
    }
  }
`
